import type { AgentConfig } from '../types/api';

export const AGENT_CONFIGS: AgentConfig[] = [
  {
    id: 'profile',
    name: 'Profile Agent',
    description: 'Querying professional identity and thesis...',
    endpoints: ['/about', '/narrative', '/thesis'],
    icon: 'user',
  },
  {
    id: 'track-record',
    name: 'Track Record Agent',
    description: 'Analyzing quantified achievements and experience...',
    endpoints: ['/accomplishments', '/track-record', '/experience'],
    icon: 'trophy',
  },
  {
    id: 'alignment',
    name: 'Alignment Agent',
    description: 'Evaluating organizational fit and capabilities...',
    endpoints: ['/seeking', '/cultural-fit', '/skills'],
    icon: 'target',
  },
  {
    id: 'synthesis',
    name: 'Intelligence Synthesis',
    description: 'Compiling intelligence brief with AI analysis...',
    endpoints: [],
    icon: 'brain',
  },
];

export const AGENT_STAGGER_MS = 800;
